import { create } from 'zustand';

interface SendChecklistStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useSendChecklistModal = create<SendChecklistStore>(set => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useSendChecklistModal;
